import {useContext} from 'react';
import {MicrosoftOAuthContext} from '../context';

export function useMicrosoftOAuth() {
    const context = useContext(MicrosoftOAuthContext);
    if (!context) {
        throw new Error(
            'Microsoft OAuth components must be used within MicrosoftOAuthProvider',
        );
    }
    return context;
}
